import { faCheck, faUndo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { IPessoas } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import { currencyFormatter } from "../../utils/currencyFormatter"
import "./style.css"

type ParamsProps = {
  tipo: "new" | "edit"
}

type IParams = {
  id: string
}

export function PessoasForm({ tipo }: ParamsProps) {
  const navigate = useNavigate()

  const { id } = useParams() as IParams
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [cadastro, setCadastro] = useState<IPessoas>({} as IPessoas)

  const loadCadastro = useCallback(async () => {
    setLoading(true)
    setTxtLoading("Carregando cadastro...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.get(`pessoas/${id}`)
      .then((res) => {
        if (!res.data)
          return

        const cad = res.data as IPessoas

        setCadastro({
          ...cad,
          valor_motor: currencyFormatter(parseFloat(`${cad.valor_motor}`), false),
          valor_ajud: currencyFormatter(parseFloat(`${cad.valor_ajud}`), false),
          hr_extra_motor: currencyFormatter(parseFloat(`${cad.hr_extra_motor}`), false),
          hr_extra_ajud: currencyFormatter(parseFloat(`${cad.hr_extra_ajud}`), false),
          valor_freelancer: currencyFormatter(parseFloat(`${cad.valor_freelancer}`), false),
        })
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar o cadastro. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, id])

  const handleSalvar = async () => {
    setLoading(true)
    setTxtLoading("Salvando...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    try {
      await api.post("pessoas", {
        ...cadastro,
        valor_motor: parseFloat((`${cadastro.valor_motor}`).replace(".", "").replace(",", ".")),
        valor_ajud: parseFloat((`${cadastro.valor_ajud}`).replace(".", "").replace(",", ".")),
        hr_extra_motor: parseFloat((`${cadastro.hr_extra_motor}`).replace(".", "").replace(",", ".")),
        hr_extra_ajud: parseFloat((`${cadastro.hr_extra_ajud}`).replace(".", "").replace(",", ".")),
        valor_freelancer: parseFloat((`${cadastro.valor_freelancer}`).replace(".", "").replace(",", ".")),
      })

      navigate("/pessoas")
    } catch (err: any) {
      if (err.response?.data?.message)
        alert(err.response?.data?.message);
      else
        alert("Erro ao salvar. Tente novamente mais tarde.");

      setLoading(false);
      setTxtLoading("");
    }
  }

  const onBlurValor = (pessoas: "motorista" | "ajudante") => {
    switch (pessoas) {
      case "motorista":
        const salarioMotor = parseFloat((`${cadastro.valor_motor}`).replace(".", "").replace(",", "."))
        const valorMotor = salarioMotor > 0 ? (salarioMotor / 220) * 1.5 : 0
        setCadastro(e => ({ ...e, hr_extra_motor: currencyFormatter(valorMotor, false) }))
        break;
      case "ajudante":
        const salarioAjud = parseFloat((`${cadastro.valor_ajud}`).replace(".", "").replace(",", "."))
        const valorAjud = salarioAjud > 0 ? (salarioAjud / 220) * 1.5 : 0
        setCadastro(e => ({ ...e, hr_extra_ajud: currencyFormatter(valorAjud, false) }))
        break;
    }
  }

  useEffect(() => {
    if (tokens?.token && tipo === "edit")
      loadCadastro()
  }, [tokens, tipo, loadCadastro])

  return (
    <div id="pgPessoasForm">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="painel form">
            <p className="title">{tipo === "new" ? "Novo" : "Editando"} Cadastro</p>

            <span style={{ width: "49%" }}>
              <label>Nome</label>
              <Input
                mask="none"
                value={`${cadastro.nome ? cadastro.nome : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, nome: v }))}
                placeholder="Nome"
              />
            </span>
            <span style={{ width: "49%" }} />

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Valor Motorista</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_motor ? cadastro.valor_motor : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_motor: v }))}
                placeholder="0,00"
                type="tel"
                onBlur={() => onBlurValor("motorista")}
              />
            </span>

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Hora Extra Motor.</label>
              <Input
                mask="currency"
                value={`${cadastro.hr_extra_motor ? cadastro.hr_extra_motor : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, hr_extra_motor: v }))}
                placeholder="0,00"
                type="tel"
              />
            </span>
            <span style={{ width: "49%" }} />

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Valor Ajudante</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_ajud ? cadastro.valor_ajud : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_ajud: v }))}
                placeholder="0,00"
                type="tel"
                onBlur={() => onBlurValor("ajudante")}
              />
            </span>

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Hora Extra Ajud.</label>
              <Input
                mask="currency"
                value={`${cadastro.hr_extra_ajud ? cadastro.hr_extra_ajud : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, hr_extra_ajud: v }))}
                placeholder="0,00"
                type="tel"
              />
            </span>
            <span style={{ width: "49%" }} />

            <span style={{ width: "24.4%", minWidth: "150px" }}>
              <label>Valor Freelancer.</label>
              <Input
                mask="currency"
                value={`${cadastro.valor_freelancer ? cadastro.valor_freelancer : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, valor_freelancer: v }))}
                placeholder="0,00"
                type="tel"
              />
            </span>

            <span style={{ width: "24%", minWidth: "150px" }}>
              <label>Carga Horária</label>
              <Input
                mask="hour"
                value={`${cadastro.carga_horario ? cadastro.carga_horario.toString().substring(0, 5) : ""}`}
                inputMaskChange={(v) => setCadastro(e => ({ ...e, carga_horario: v }))}
                placeholder="00:00"
                maxLength={5}
                type="time"
              />
            </span>

          </div>

          <div className="btnPainel">
            <button className="btn-purple" onClick={() => { navigate(-1) }}>
              <FontAwesomeIcon icon={faUndo} />
              VOLTAR
            </button>

            <button className="btn-green" onClick={() => { handleSalvar() }}>
              <FontAwesomeIcon icon={faCheck} />
              SALVAR
            </button>
          </div>
        </>
      )}

    </div>
  )
}